import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Location } from '@angular/common';
import { BookingDataForm, BookingWorkflowData } from '../booking/model/booking.model';
import { CartridgeBookingService } from '../services/cartridge-booking.service';

@Component({
  selector: 'markant-platform-booking-form',
  templateUrl: './booking-form.component.html',
  styleUrls: ['./booking-form.component.scss'],
})
export class BookingFormComponent implements OnInit {
  @Input() bookingData!: BookingWorkflowData;
  @Input() additionalBookingDataForm!: BookingDataForm;

  @Output() goNext: EventEmitter<void> = new EventEmitter<void>();

  submitted = false;

  constructor(
    private location: Location,
    private readonly cartridgeBookingService: CartridgeBookingService
  ) {}

  ngOnInit(): void {
    this.additionalBookingDataForm.patchValue({
      billingEmail: this.bookingData.billingEmail || this.bookingData.organization.billingEmail,
      billingLanguageIsoCode:
        this.bookingData.billingLanguageIsoCode?.toLowerCase() ||
        this.bookingData.organization.billingLanguageIsoCode?.toLowerCase(),
    });

    !!this.bookingData.organization.billingEmail && this.additionalBookingDataForm.controls.billingEmail.disable();
    !!this.bookingData.organization.billingLanguageIsoCode &&
      this.additionalBookingDataForm.controls.billingLanguageIsoCode.disable();

    window.scroll(0, 0);
  }

  submit(): void {
    this.submitted = true; // added by request to trigger errors earliest at submit

    if (this.additionalBookingDataForm.valid) {
      this.goNext.emit();
      this.cartridgeBookingService.pushTrackingEventData('Step 01 - Your data', this.bookingData, 'Click - Continue');
    }
  }

  goBack(): void {
    this.location.back();
    this.cartridgeBookingService.pushTrackingEventData('Step 01 - Your data', this.bookingData, 'Click - Back');
  }
}
